// js/components/BuyButton.js
import { Form, Animation } from '../utils.js';

export class BuyButton extends HTMLElement {
  constructor() {
    super();
    this._onClickListener = this._addToCart.bind(this);
  }
  
  connectedCallback() {
    this.addEventListener("click", this._onClickListener);
  }
  
  disconnectedCallback() {
    this.removeEventListener("click", this._onClickListener);
  }
  
  _addToCart(event) {
    event.preventDefault();
    event.stopPropagation();
    
    const button = this.querySelector("button[type='submit']");
    const formElement = button.closest('form[action*="/cart/add"]');
    
    button.setAttribute("disabled", "disabled");
    document.dispatchEvent(new CustomEvent("theme:loading:start"));
    
    fetch(`${window.routes.cartAddUrl}.js`, {
      body: JSON.stringify(Form.serialize(formElement)),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest"
        // This is needed as currently there is a bug in Shopify that assumes this header
      }
    }).then((response) => {
      button.removeAttribute("disabled");
      
      const targetElement = this._getTargetElement(button);
      
      const quantity = parseInt(formElement.querySelector('[name="quantity"]').value);
      
      this.dispatchEvent(new CustomEvent("product:added", {
        bubbles: true,
        detail: {
          button,
          variant: null,
          quantity,
          productAdded: response.ok
        }
      }));
      
      if (response.ok) {
        this._handleSuccessfulAdd();
      } else {
        response.json().then((content) => {
          this._showAlert(content["description"], "error", targetElement);
        });
        document.dispatchEvent(new CustomEvent("theme:loading:end"));
      }
    });
  }
  
  _getTargetElement(button) {
    const sectionType = button.closest("[data-section-type]")?.getAttribute("data-section-type");
    
    if (sectionType === "product" || sectionType === "product-quick-view") {
      return button.closest(".product-form");
    }
    
    return document.querySelector(".header") || document.body;
  }
  
  _handleSuccessfulAdd() {
    if (theme.pageType === "cart" || window.theme.cartType === "page") {
      window.location.href = window.routes.cartUrl;
      return;
    }
    
    if (window.theme.cartType === "drawer") {
      document.dispatchEvent(new CustomEvent("modal:close"));
    }
    
    if (window.theme.cartType === "message") {
      const targetElement = this._getTargetElement(this);
      this._showAlert(window.languages.productAdded, "success", targetElement);
    }
  }
  
  _showAlert(message, type, afterElement) {
    const sectionType = afterElement.closest("[data-section-type]")?.getAttribute("data-section-type");
    const messageElement = document.createElement("div");
    
    messageElement.className = `cart__status-message cart__status-message--${sectionType}`;
    messageElement.innerHTML = `
      <div class="alert ${type === "success" ? "alert--success" : "alert--error"}">
        <p ${sectionType === "header" ? 'class="container"' : ""}>${message}</p>
      </div>
    `;
    
    afterElement.append(messageElement);
    Animation.slideDown(messageElement);
    
    setTimeout(() => {
      Animation.slideUp(messageElement, () => {
        messageElement.remove();
      });
    }, 5500);
  }
}

if (!window.customElements.get("cos-buy-button")) window.customElements.define("cos-buy-button", BuyButton);